class PromiseCache {
  private cache: Map<string, Promise<any>>;
  private cacheDuration: number;

  constructor(cacheDuration: number = 5000) {
    this.cache = new Map();
    this.cacheDuration = cacheDuration;
  }

  get(promiseProvider: () => Promise<any>, keys: string | string[]) {
    if (typeof keys === 'string') {
      keys = [keys];
    }
    const key = keys.join(':');
    if (!this.cache.has(key)) {
      const promise = promiseProvider()
        .catch((error) => {
          // Ensure that errors are not cached
          this.cache.delete(key);
          throw error;
        })
        .then((data) => {
          // Schedule cache invalidation
          setTimeout(() => {
            this.cache.delete(key);
          }, this.cacheDuration);
          return data;
        });
      this.cache.set(key, promise);
    }
    return this.cache.get(key)!;
  }
}

export default new PromiseCache();
